export default __webpack_public_path__ + "static/media/bathroom1-after-1024w.39b5b0a6.webp";